export class SingleHandlerEventBus {
    constructor() {
        this.handlers = new Map();
        this.queuedEvents = new Map();
    }
    emit(type, payload) {
        const handler = this.handlers.get(type);
        if (handler) {
            handler(payload);
        }
        else {
            const queue = this.queuedEvents.get(type);
            if (queue) {
                queue.push(payload);
            }
            else {
                this.queuedEvents.set(type, [payload]);
            }
        }
    }
    on(type, handler) {
        if (this.handlers.has(type)) {
            console.warn(`Handler for event type '${String(type)}' is already registered. Ignoring duplicate registration.`);
            return;
        }
        this.handlers.set(type, handler);
        const queuedPayloads = this.queuedEvents.get(type);
        if (queuedPayloads && queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload) => handler(payload));
            this.queuedEvents.delete(type);
        }
    }
}
